import { fetchData } from "../api/api";

const isAdmin = async () => {
  const role = await fetchData("accounts/is_admin");
  return role;
};

export default isAdmin;
